export default function Demo() {
    return (
        <div className="flex flex-col items-center pb-12 pt-20 sm:pt-24">
            <div className="mx-auto max-w-2xl text-center">
                <h2 className="text-lg p-0 sm:p-6 font-semibold text-custom-orange">See it in action</h2>
                <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                    "but I've tried these<br />tools and they generate garbage"
                </p>
            </div>
            <div className="w-full md:w-3/4 lg:w-3/4 mx-auto mt-16 sm:mt-20">
                <div className="relative" style={{ paddingTop: "56.25%" }}>
                    <iframe className="absolute inset-0 w-full h-full" src="https://player.vimeo.com/video/962672562?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" allow="autoplay; fullscreen; picture-in-picture"></iframe>
                </div>
            </div>

        </div>
    )
}